import React from 'react';

import { useWidgetParam } from '@src/core/hooks';
import useTranslate from '@src/i18n/useTranslate';
import { IconBrandWhatsapp, IconCoin } from '@planne-software/uni/icons';
import { track } from '@src/services/analytics';

import { buildCashbackWhatsappUrl } from '../../core/cashbackWhatsapp';
import type { CashbackGrowthOrderSnapshot } from '../../core/cashbackGrowthOrderSnapshot';

import {
  GrowthCardGlow,
  GrowthCardIcon,
  GrowthCardMessage,
  GrowthCardRedeemButton,
  GrowthCardRoot,
  GrowthCardText,
} from './styles';

export type CashbackGrowthCardProps = {
  snapshot: CashbackGrowthOrderSnapshot;
};

export const CashbackGrowthCard = (props: CashbackGrowthCardProps) => {
  const { snapshot } = props;
  const { i18n, i18nElement } = useTranslate();
  const sellerName = useWidgetParam('business-name') ?? '';

  const handleRedeem = () => {
    track('cashbackGrowthRedeem', { orderCode: snapshot.code, surface: 'account' });
    window.open(
      buildCashbackWhatsappUrl({
        buyerFirstName: snapshot.buyerFirstName,
        sellerName,
        orderCode: snapshot.code,
        amountCents: snapshot.amountCents,
      }),
      '_blank',
      'noopener',
    );
  };

  return (
    <GrowthCardRoot data-testid='cashback-growth-card'>
      <GrowthCardGlow aria-hidden />
      <GrowthCardMessage>
        <GrowthCardIcon>
          <IconCoin size={24} aria-hidden />
        </GrowthCardIcon>
        <GrowthCardText>
          {snapshot.buyerFirstName
            ? i18nElement('cashback_growth_card_with_name', { name: snapshot.buyerFirstName })
            : i18nElement('cashback_growth_card_without_name')}
        </GrowthCardText>
      </GrowthCardMessage>
      <GrowthCardRedeemButton type='button' onClick={handleRedeem}>
        <IconBrandWhatsapp size={15} aria-hidden />
        {i18n('cashback_growth_redeem_short')}
      </GrowthCardRedeemButton>
    </GrowthCardRoot>
  );
};

export default CashbackGrowthCard;
